import {FILTERS_ARGS} from "@/app/exercise/modules/trainings/core/training-const";

export class ExamFiltersDTO {
  constructor(queries = {}) {
    this.is_auto = queries[FILTERS_ARGS.IS_AUTO];
    this.is_motor = queries[FILTERS_ARGS.IS_MOTOR];
    this.is_scooter = queries[FILTERS_ARGS.IS_SCOOTER];
    this.tenant = queries[FILTERS_ARGS.TENANT];
  }
}